import styled from 'styled-components';

import BackSvg from '@web/assets/svg/UI/back.svg';

export const BackButton = styled.button`
  border: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.white};
  margin-top: 20px;
  padding: 13px 30px;
  width: 100%;
`;

export const BackIcon = styled(BackSvg)`
  opacity: 0.65;
`;
